import React, { useState, useEffect } from 'react';
import { Package } from 'lucide-react';

interface ProductImageProps {
  src?: string | null;
  alt: string;
  className?: string;
  loading?: 'lazy' | 'eager';
}

const ProductImage: React.FC<ProductImageProps> = ({
  src,
  alt,
  className = "h-full w-full object-cover",
  loading = "lazy"
}) => {
  const [error, setError] = useState(false);

  // Reset error state if src changes
  useEffect(() => {
    setError(false);
  }, [src]);

  if (!src || error) {
    return (
      <div className="flex h-full w-full items-center justify-center bg-[#F4F2EE] text-[#8C7E74] select-none rounded-[inherit]">
        <Package className="h-[35%] w-[35%] min-h-[20px] min-w-[20px] max-h-[48px] max-w-[48px]" strokeWidth={1.5} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      onError={() => setError(true)}
      className={className}
    />
  );
};

export default ProductImage;
